import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";
import { OneOnOnePage } from "@/features/growthpeople/OneOnOnePage";

const search = z.object({
  tab: z.enum(["agenda", "notes"]).optional(),
});

export const Route = createFileRoute("/_app/one-on-ones/$person")({
  validateSearch: search,
  component: () => {
    const { person } = Route.useParams();
    return <OneOnOnePage person={person} tab={Route.useSearch().tab ?? "agenda"} />;
  },
});
